module.exports = __webpack_public_path__ + "img/teaser_003.1347183b.png";